import { waitAsync } from '../utils';
import { Route } from 'react-router-dom';

const ListNoticesAction = "LIST_NOTICES";
const Waiting = "WAITNG_NOTICE";

const initialState = {
    list: [],
    nowWainting: false
};
export const actionCreators = {
    /**
     * お知らせ一覧を取得します。
     */
    listNotices: (token) => async (dispatch) => {
        const routeurl = `api/user/notices/list`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const list = await response.json();
                dispatch({ type: ListNoticesAction, list });
                return list;
            } else {
                throw new Error('お知らせ一覧取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },
}

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListNoticesAction) {
        return {
            ...state,
            list: action.list,
            nowWainting: action.nowWainting
        };
    }
    return state;
}